// Backend rejects PageInput.size above TimberbaseProperties.maxPageSize (100).
export const DRILL_DOWN_PAGE_SIZE = 20;

// Without a platformProductLengthId a page holds one row per facility x length, so this uses the backend's largest allowed size to keep "load more" clicks proportional to facility count.
export const FACILITY_PICKER_PAGE_SIZE = 100;
